<div class="contas-section">
  <h3 class="section-title">
    <i class="pi" [class.pi-wallet]="tipo === 'pagar'" [class.pi-money-bill]="tipo === 'receber'"></i>
    {{ titulo }}
  </h3>
  <p class="section-subtitle">
    <i class="pi pi-calendar"></i>
    {{ texts.filtro_por_vencimento }}
  </p>

  <!-- Filtros locais de conta e periodo -->
  <div class="filtros-contas">
    <p-dropdown
      [options]="contaOptions"
      [(ngModel)]="contaSelecionadaLocal"
      [placeholder]="texts.filtrar_conta"
      (onChange)="onContaSelect($event)"
      styleClass="p-dropdown-sm filtro-dropdown">
      <ng-template pTemplate="selectedItem" let-conta>
        <div class="dropdown-conta-item" *ngIf="conta">
          <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
          <span>{{ conta.label }}</span>
        </div>
      </ng-template>
      <ng-template pTemplate="item" let-conta>
        <div class="dropdown-conta-item">
          <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
          <span>{{ conta.label }}</span>
        </div>
      </ng-template>
    </p-dropdown>

    <app-periodo-filtro
      modo="avancado"
      [opcoes]="opcoesPeriodo"
      [valorPadrao]="'showAll'"
      [persistir]="true"
      [textoExibicao]="periodoSelecionadoLocal?.texto || texts.filtrar_periodo"
      styleClass="p-dropdown-sm filtro-dropdown"
      (periodoChanged)="onPeriodoChanged($event)">
    </app-periodo-filtro>
  </div>

  <!-- Cards de totais — clicáveis para navegar com os filtros ativos -->
  <div class="totais-row">
    <div class="total-card aberto total-card-clicavel" (click)="totalAbertoClicado.emit()">
      <span class="total-label">{{ labelAberto }}</span>
      <span class="total-valor vermelho-text">
        {{ totalAberto | currency:currencySymbol:'symbol-narrow':currencyDigits:currencyLocale }}
      </span>
    </div>
    <div class="total-card pago total-card-clicavel" (click)="totalPagoClicado.emit()">
      <span class="total-label">{{ labelPago }}</span>
      <span class="total-valor verde-text">
        {{ totalPago | currency:currencySymbol:'symbol-narrow':currencyDigits:currencyLocale }}
      </span>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
  </div>

  <!-- Tabela -->
  <div *ngIf="!loading && contas.length > 0">
    <p-table [value]="contas" [paginator]="false" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ texts.nome }}</th>
          <th>{{ texts.primeiro_vencimento }}</th>
          <th class="text-verde">{{ colunaValor }}</th>
          <th class="text-verde">{{ colunaRecebido }}</th>
          <th *ngIf="temDevolvido" class="text-laranja">{{ texts.devolvido }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-conta let-rowIndex="rowIndex">
        <tr (click)="onContaClicada(conta)" class="linha-clicavel"
            [class.linha-par]="rowIndex % 2 === 0">
          <td>{{ conta.nomePessoa }}</td>
          <td>{{ formatarData(conta.primeiroVencimento) }}</td>
          <td class="valor-principal">
            {{ conta.totalAReceber | currency:currencySymbol:'symbol-narrow':currencyDigits:currencyLocale }}
          </td>
          <td class="valor-principal">
            {{ conta.totalRecebido | currency:currencySymbol:'symbol-narrow':currencyDigits:currencyLocale }}
          </td>
          <td *ngIf="temDevolvido" class="valor-devolvido">
            {{ conta.valorDevolvido | currency:currencySymbol:'symbol-narrow':currencyDigits:currencyLocale }}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="mostrar-mais" *ngIf="contas.length >= 5">
      <button pButton type="button"
              [label]="texts.mostrar_mais"
              class="p-button-text p-button-sm"
              (click)="mostrarMaisClicado.emit()">
      </button>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && contas.length === 0" class="empty-state">
    <i class="pi pi-inbox"></i>
    <span class="empty-state-text">{{ texts.sem_registros }}</span>
  </div>
</div>
